module.exports = __webpack_public_path__ + "jobs-2ec46bc8/bookmark-c98c34d9b1d2ede4441a7c57b7958c54.svg";